/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetBindingDataQueryDto
 */
export interface GetBindingDataQueryDto {
    /**
     * 
     * @type {string}
     * @memberof GetBindingDataQueryDto
     */
    submissionId: string;
    /**
     * 
     * @type {string}
     * @memberof GetBindingDataQueryDto
     */
    currency?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetBindingDataQueryDto
     */
    includeBinder?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBindingDataQueryDto
     */
    includeReinsured?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBindingDataQueryDto
     */
    includeBroker?: boolean;
}

/**
 * Check if a given object implements the GetBindingDataQueryDto interface.
 */
export function instanceOfGetBindingDataQueryDto(value: object): value is GetBindingDataQueryDto {
    if (!('submissionId' in value) || value['submissionId'] === undefined) return false;
    return true;
}

export function GetBindingDataQueryDtoFromJSON(json: any): GetBindingDataQueryDto {
    return GetBindingDataQueryDtoFromJSONTyped(json, false);
}

export function GetBindingDataQueryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBindingDataQueryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'submissionId': json['submissionId'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'includeBinder': json['includeBinder'] == null ? undefined : json['includeBinder'],
        'includeReinsured': json['includeReinsured'] == null ? undefined : json['includeReinsured'],
        'includeBroker': json['includeBroker'] == null ? undefined : json['includeBroker'],
    };
}

export function GetBindingDataQueryDtoToJSON(json: any): GetBindingDataQueryDto {
    return GetBindingDataQueryDtoToJSONTyped(json, false);
}

export function GetBindingDataQueryDtoToJSONTyped(value?: GetBindingDataQueryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'submissionId': value['submissionId'],
        'currency': value['currency'],
        'includeBinder': value['includeBinder'],
        'includeReinsured': value['includeReinsured'],
        'includeBroker': value['includeBroker'],
    };
}

